<template>
    <div>
      <div class="content">
        <div class="body">
          <!-- Error Message -->
          <p v-if="error" class="text-danger"><i class="bi bi-exclamation-circle"></i> {{ error }}</p>
  
          <!-- Student ID -->
          <p><strong>Student Item ID:</strong> {{ studentItemId }}</p>
  
          <!-- Bootstrap Grid for Alignment -->
          <div class="row">
            <!-- Left Section - Student Details -->
            <div class="col-md-6">
              <div v-if="student" class="mb-4 p-3 border rounded">
                <h3><i class="bi bi-person-circle"></i> Student Details</h3>
                <p><strong>Name:</strong> {{ student.first_name }} {{ student.last_name }}</p>
                <p><strong>Grade:</strong> {{ student.grade_id }}</p>
                <p><strong>Institute:</strong> {{ student.institute.institute_name }}</p>
              </div>

  
              <!-- Student Items Section -->
              <div v-if="studentItem" class="border p-3 mb-3 rounded">
    <div>
      <h3><i class="bi bi-journal-text"></i>Payment Details</h3>
      <p>Amount: {{ studentItem.amount }}</p>
      <p>Payment Type: {{ studentItem.pay_type.payment_type }}</p>
      <p>Payment Date: {{ studentItem.payment_date }}</p>
      <p>Expiration Date: {{ studentItem.exp_date }}</p>
      <p>Status: {{ studentItem.student_status.name }}</p>
    </div>

    <!-- Display Subject Info -->
    <div>
      <h3>Subject</h3>
      <p>Subject Name: {{ studentItem.subject.name }}</p>
      <p>Teacher Name: {{ studentItem.teacher.user.first_name }} {{ studentItem.teacher.user.last_name }}</p>
    </div>

  </div>
  
              <!-- Student Code Section -->
             <!-- Student Code -->
          <div v-if="studentCodes" class="mb-4 p-3 border rounded">
            <h3><i class="bi bi-key"></i> Student Code</h3>
            <!-- <p><strong>Wave Code:</strong> {{ studentCodes.wave_code }}</p> -->
            <p><strong>Wave Code:</strong> {{ studentCodes[0].wave_code }}</p>
            <p><strong>Wave Code:</strong> {{ studentCodes[0].wave_qr_code }}</p>
          </div>
            </div>
  
            <!-- Right Section - Payment and Remarks -->
            <div class="col-md-6">
              <div v-if="studentItem" class="mb-4 p-3 border rounded">
  <h3><i class="bi bi-credit-card"></i> Add Payment</h3>

  <div class="border p-3 mb-3 rounded">
    <p><strong>Payment Type:</strong> {{ studentItem.pay_type.payment_type }} (ID: {{ studentItem.pay_type.id }})</p>

    <label for="paymentOption"><strong>Select Payment Option:</strong></label>
    <select v-model="studentItem.selectedOption" class="form-select mb-3">
  <option value="default" disabled>Select Amount</option>
  <option value="full">Full Payment - {{ studentItem.amount }}</option>
  <option value="three_quarter">Three-Quarter Payment - {{ (studentItem.amount * 0.75).toFixed(2) }}</option>
  <option value="half">Half Payment - {{ (studentItem.amount / 2).toFixed(2) }}</option>
  <option value="quarter">Quarter Payment - {{ (studentItem.amount / 4).toFixed(2) }}</option>
</select>


<p><strong>Selected Amount:</strong> 
  <span v-if="getDisplayedAmount(studentItem) === 'Not Selected'">
    {{ getDisplayedAmount(studentItem) }}
  </span>
  <span v-else>
    Rs. {{ parseFloat(getDisplayedAmount(studentItem)).toFixed(2) }}
  </span>
</p>


  </div>
</div>

  
              <!-- Attendance Status -->
              <div class="mb-3 p-3 border rounded">
                <label for="attendanceStatus" class="form-label"><i class="bi bi-person-check"></i> Attendance Status</label>
                <select id="attendanceStatus" v-model="attendanceStatus" class="form-select" required>
                  <option value="Present">Present</option>
                  <option value="Absent">Absent</option>
                  <option value="Late">Late</option>
                </select>
              </div>
  
              <!-- Remark Section -->
              <div class="mb-3 p-3 border rounded">
                <label for="remark" class="form-label"><i class="bi bi-chat-left-text"></i> Remark</label>
                <textarea id="remark" v-model="remark" class="form-control" rows="4" placeholder="Add any remark here"></textarea>
              </div>
            </div>
          </div>

          <button class="btn btn-success mt-3" @click="submitPayment">
            <i class="bi bi-save"></i> Submit Payments
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'StudentAddPayment',
  
    props: {
      studentItemId: {
        type: Number,
        required: true,
      },
    },
  
    data() {
      return {
        student: null,
        studentCodes: null,
        // studentItems: [],
        studentItem: null,  // Initialize as null
        error: null,
        attendanceStatus: "Present",
        remark: "",
      };
    },
  
    methods: {
      // Fetch student details using student_id
      fetchStudentDetails() {
    axios
      .post(`/get-student-qr-details-addpayment`, {
        student_item_id: this.studentItemId,
      })
      .then((response) => {
        // Ensure response contains student data
        this.studentItem = response.data.student_item;
        this.studentCodes = response.data.student_codes;
        this.student = response.data.student;
      })
      .catch((error) => {
        this.error = "Error fetching student details.";
        console.error("Error fetching student details:", error);
      });
  },
  
      // Display selected amount for payments
      getDisplayedAmount(studentItem) {
  const amount = studentItem.amount;
  if (!studentItem.selectedOption || studentItem.selectedOption === 'default') {
    return "Not Selected"; // Return "Not Selected" if no option is chosen
  }
  switch (studentItem.selectedOption) {
    case "full":
      return amount;
    case "three_quarter":
      return (amount * 0.75).toFixed(2);
    case "half":
      return (amount / 2).toFixed(2);
    case "quarter":
      return (amount / 4).toFixed(2);
    default:
      return "Not Selected";
  }
},

currencyFormat(value) {
    if (!value || isNaN(value)) return 'Not Selected';
    return 'Rs. ' + parseFloat(value).toFixed(2);
  },

      submitPayment() {
  this.error = null;

  const now = new Date();
  const payment_date = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

  const selectedOption = this.studentItem.selectedOption;

  if (!selectedOption || selectedOption === 'default') {
    alert("Please select a payment option before submitting.");
    return;
  }

  const payment = {
    student_id: this.studentItem.student.id,
    student_item_id: this.studentItem.id,
    pay_type_id: this.studentItem.pay_type.id,
    amount: this.getDisplayedAmount(this.studentItem),
    payment_option: selectedOption,
    payment_date: payment_date,
    payment_status: 1,
    payment_month: new Date().toLocaleString('default', { month: 'long' }),
    payment_day: now.getDate(),
    payment_week_of_month: Math.ceil(now.getDate() / 7),
    remark: this.remark,
    attendance_status: this.attendanceStatus,
  };

  axios.post('/save-student-payment', payment)
    .then(() => {
      alert("Payment saved successfully!");
    })
    .catch(error => {
      let errorMsg = "Failed to save the payment.";
      if (error.response && error.response.data && error.response.data.message) {
        errorMsg = error.response.data.message;
      }
      this.error = errorMsg;
      alert(`⚠️ ${errorMsg}`);
      console.error("Payment error:", error);
    });
}


    },
  
    mounted() {
      this.fetchStudentDetails();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  /* Add your styling here */
  </style>
  